import { CheckboxFilterOption } from '../types';
import { FilterCheckbox } from '../../components';

export const config: CheckboxFilterOption = {
  id: 'omicsExplorer.filters.cancerKnowledgeBase',
  title: {
    id: 'omicsExplorer.filters.cancerKnowledgeBase',
    defaultMessage: 'Cancer Knowledgebase (CKB)',
  },
  content: FilterCheckbox,
  injectedProps: {
    searchKey: 'drugAssociations',
    checkboxOption: {
      id: 'omics-explorer-cancerknowledgebase-drugassociations',
      searchValue: false,
      intlLabel: {
        id: 'omicsExplorer.filters.cancerKnowledgeBase.checkbox',
        defaultMessage: 'In CKB',
      },
    },
  },
};
